import { render, staticRenderFns } from "./promoLocalTable.vue?vue&type=template&id=12b841ab"
import script from "./promoLocalTable.vue?vue&type=script&lang=js"
export * from "./promoLocalTable.vue?vue&type=script&lang=js"
import style0 from "./promoLocalTable.vue?vue&type=style&index=0&id=12b841ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports